import FormTextEditor from './FormTextEditor';

export default FormTextEditor;
